import { Styled } from './';
import React from 'react';
import Bugsnag from '@bugsnag/js';
import { setUpBugsnag } from 'config/setupBugsnag';
import { useI18n } from 'contexts/i18n';

if (process.env.NODE_ENV !== 'test') {
  setUpBugsnag();
}

const ErrorBoundary =
  process.env.NODE_ENV !== 'test'
    ? Bugsnag?.getPlugin('react')?.createErrorBoundary(React) ?? React.Component
    : React.Component;

const GlobalErrorFallback = (props: any) => {
  const errorCode = props?.error?.response?.status;

  const i18n = useI18n();

  return (
    <Styled.ErrorMessageContainer>
      {/* {errorCode === 403 && (
        <>
          <Styled.ErrorTitle>{i18n['Unauthorized Access.']}</Styled.ErrorTitle>
          <Styled.ErrorDescription>
            <br />
            {i18n['You are not authorized to access Global Store.']}
            <br />
            <br />
            {
              i18n[
                'Please contact Tech Support if you feel you have reached this message in error.'
              ]
            }
            <br />
            <br />
            {
              i18n[
                'Please note that other areas in the Invisalign Doctor Site are available.'
              ]
            }
          </Styled.ErrorDescription>
        </>
      )} */}
      {errorCode !== 403 && (
        <>
          <Styled.ErrorTitle>
            {i18n['Sorry, Global Store has encountered an Error.']}
          </Styled.ErrorTitle>
          <Styled.ErrorDescription>
            <br />
            {
              i18n[
                'Global Store has encountered an Error in the page you have requested.'
              ]
            }

            <br />
            {
              i18n[
                'We are working to resolve the issue as quickly as possible and regret any inconvenience to you.'
              ]
            }

            <br />
            {
              i18n[
                'In case the issue is not resolved. Please contact customer care with the Error Code'
              ]
            }

            <br />
            <br />
            <br />
            {
              i18n[
                'Please note that other areas in the Invisalign Doctor Site are available.'
              ]
            }
          </Styled.ErrorDescription>
        </>
      )}
    </Styled.ErrorMessageContainer>
  );
};

export { ErrorBoundary, GlobalErrorFallback };
